import script from "./SiteLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteLogo.vue?vue&type=script&setup=true&lang=js"

import "./SiteLogo.vue?vue&type=style&index=0&id=3c671f1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c671f1e"]])

export default __exports__